module.exports = "/_next/static/images/eb4d5d7bb00936bb4187e863708042a7-mulher-com-cachos-maravilhosos-segurando-cartao-md@3x.jpg.webp";